import React from 'react';
function VisaIcon({
  className = ''
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 48 32" className={`h-6 w-auto ${className}`} fill="none" aria-label="Visa" data-id="element-94">
      <rect width="48" height="32" rx="4" fill="#FFFFFF" data-id="element-95" />
      <rect x="0.5" y="0.5" width="47" height="31" rx="3.5" stroke="#E6E6E6" strokeWidth="1" data-id="element-96" />
      <text x="24" y="20.5" textAnchor="middle" fontSize="14" fontWeight="800" fill="#1A1F71" fontFamily="Arial, Helvetica, sans-serif" letterSpacing="1" fontStyle="italic" data-id="element-97">
        VISA
      </text>
    </svg>;
}
function MastercardIcon({
  className = ''
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 48 32" className={`h-6 w-auto ${className}`} fill="none" aria-label="Mastercard" data-id="element-98">
      <rect width="48" height="32" rx="4" fill="#FFFFFF" data-id="element-99" />
      <rect x="0.5" y="0.5" width="47" height="31" rx="3.5" stroke="#E6E6E6" strokeWidth="1" data-id="element-100" />
      <circle cx="19" cy="16" r="8.5" fill="#EB001B" data-id="element-101" />
      <circle cx="29" cy="16" r="8.5" fill="#F79E1B" data-id="element-102" />
      <path d="M24 9.15C25.95 10.75 27.2 13.15 27.2 15.85C27.2 18.55 25.95 20.95 24 22.55C22.05 20.95 20.8 18.55 20.8 15.85C20.8 13.15 22.05 10.75 24 9.15Z" fill="#FF5F00" data-id="element-103" />
    </svg>;
}
function AmexIcon({
  className = ''
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 48 32" className={`h-6 w-auto ${className}`} fill="none" aria-label="American Express" data-id="element-104">
      <rect width="48" height="32" rx="4" fill="#016FD0" data-id="element-105" />
      <text x="24" y="19" textAnchor="middle" fontSize="10" fontWeight="800" fill="white" fontFamily="'Helvetica Neue', Arial, sans-serif" letterSpacing="1.5" data-id="element-106">
        AMEX
      </text>
    </svg>;
}
function ApplePayIcon({
  className = ''
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 48 32" className={`h-6 w-auto ${className}`} fill="none" aria-label="Apple Pay" data-id="element-107">
      <rect width="48" height="32" rx="4" fill="#000000" data-id="element-108" />
      <path d="M15.2 10.8C15.7 10.2 16 9.4 15.9 8.6C15.2 8.65 14.3 9.1 13.8 9.7C13.35 10.25 12.95 11.05 13.05 11.85C13.8 11.9 14.65 11.45 15.2 10.8Z" fill="white" data-id="element-109" />
      <path d="M15.9 12C14.85 11.95 13.95 12.6 13.45 12.6C12.95 12.6 12.15 12.05 11.3 12.05C10.2 12.1 9.2 12.7 8.65 13.65C7.5 15.55 8.35 18.4 9.45 19.95C10 20.7 10.65 21.55 11.5 21.5C12.3 21.5 12.65 21 13.65 21C14.65 21 14.95 21.5 15.8 21.5C16.65 21.5 17.25 20.7 17.8 19.95C18.4 19.1 18.65 18.3 18.65 18.25C18.65 18.25 17.05 17.6 17.05 15.75C17.05 14.15 18.35 13.4 18.4 13.35C17.65 12.25 16.5 12.05 15.9 12Z" fill="white" data-id="element-110" />
      <text x="28" y="18" fontSize="8" fontWeight="600" fill="white" fontFamily="-apple-system, BlinkMacSystemFont, 'SF Pro', Arial, sans-serif" data-id="element-111">
        Pay
      </text>
    </svg>;
}
function PayPalIcon({
  className = ''
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 48 32" className={`h-6 w-auto ${className}`} fill="none" aria-label="PayPal" data-id="element-112">
      <rect width="48" height="32" rx="4" fill="#FFFFFF" data-id="element-113" />
      <rect x="0.5" y="0.5" width="47" height="31" rx="3.5" stroke="#DADCE0" strokeWidth="1" data-id="element-114" />
      <path d="M19.5 9H14.5C14.2 9 13.95 9.2 13.9 9.5L12 21.5C11.95 21.75 12.15 21.95 12.4 21.95H14.8C15.1 21.95 15.35 21.75 15.4 21.45L15.9 18.5C15.95 18.2 16.2 18 16.5 18H17.8C20.5 18 22.05 16.65 22.45 14.05C22.65 12.9 22.45 12 21.95 11.35C21.35 10.55 20.3 9 19.5 9Z" fill="#003087" data-id="element-115" />
      <path d="M25.5 9H20.5C20.2 9 19.95 9.2 19.9 9.5L18 21.5C17.95 21.75 18.15 21.95 18.4 21.95H21C21.2 21.95 21.35 21.8 21.4 21.6L21.9 18.5C21.95 18.2 22.2 18 22.5 18H23.8C26.5 18 28.05 16.65 28.45 14.05C28.65 12.9 28.45 12 27.95 11.35C27.35 10.55 26.3 9 25.5 9Z" fill="#009CDE" data-id="element-116" />
      <text x="33" y="18" fontSize="5.5" fontWeight="700" fill="#003087" fontFamily="Arial, sans-serif" data-id="element-117">
        Pay
      </text>
      <text x="33" y="23" fontSize="5.5" fontWeight="700" fill="#009CDE" fontFamily="Arial, sans-serif" data-id="element-118">
        Pal
      </text>
    </svg>;
}
function ShopPayIcon({
  className = ''
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 48 32" className={`h-6 w-auto ${className}`} fill="none" aria-label="Shop Pay" data-id="element-119">
      <rect width="48" height="32" rx="4" fill="#5A31F4" data-id="element-120" />
      <path d="M14 12.5C14 11.12 15.12 10 16.5 10C17.88 10 19 11.12 19 12.5V13H14V12.5Z" stroke="white" strokeWidth="1.2" fill="none" data-id="element-121" />
      <rect x="12.5" y="13" width="8" height="9" rx="1" fill="white" data-id="element-122" />
      <path d="M14.5 16C14.5 16 15 17.5 16.5 17.5C18 17.5 18.5 16 18.5 16" stroke="#5A31F4" strokeWidth="1" strokeLinecap="round" data-id="element-123" />
      <text x="27" y="14.5" fontSize="5.5" fontWeight="700" fill="white" fontFamily="Arial, sans-serif" letterSpacing="0.3" data-id="element-124">
        shop
      </text>
      <text x="27" y="21" fontSize="6.5" fontWeight="800" fill="white" fontFamily="Arial, sans-serif" letterSpacing="0.3" data-id="element-125">
        pay
      </text>
    </svg>;
}
export function PaymentIconsRow({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`flex flex-wrap items-center justify-center gap-3 ${className}`} data-id="element-126">
      <VisaIcon data-id="element-127" />
      <MastercardIcon data-id="element-128" />
      <AmexIcon data-id="element-129" />
      <PayPalIcon data-id="element-130" />
      <ApplePayIcon data-id="element-131" />
      <ShopPayIcon data-id="element-132" />
    </div>;
}